import React from 'react';

import { Box } from '@twilio-paste/core/box';
import { Label } from '@twilio-paste/core/label';

interface PanelConfig {
  title: string;
}

interface SearchCustomerPageActionProps {
  panels: PanelConfig[];
  visiblePanels: boolean[];
  onToggle: (idx: number) => void;
}

export function SearchCustomerPageActions({ panels, visiblePanels, onToggle }: SearchCustomerPageActionProps) {
  return (
    <Box display="flex" columnGap="space40">
      {panels.map((panel, idx) => (
        <Box key={panel.title} display="flex" alignItems="center">
          <Label htmlFor={`toggle-panel-${idx}`}>{panel.title}</Label>
          <Box marginLeft="space20">
            <input
              id={`toggle-panel-${idx}`}
              type="checkbox"
              checked={visiblePanels[idx]}
              onChange={() => onToggle(idx)}
              style={{ width: 18, height: 18 }}
            />
          </Box>
        </Box>
      ))}
    </Box>
  );
}

